import { apiClient } from "./client";

export const storageAPI = {
  getAggregates() {
    return apiClient.get(`/storage/aggregates`);
  },
  getAggregatesDetail(aggr_name) {
    return apiClient.get(`/storage/aggregates/${aggr_name}`);
  },
  getSVMs() {
    return apiClient.get(`/storage/svms`);
  },
  getSVMsDetail(svm_name) {
    return apiClient.get(`/storage/svms/${svm_name}`);
  },
  createVolumes(svm_name, volume_name, path, size, aggr_name) {
    return apiClient.post(`/storage/volumes`, {
      svm_name,
      volume_name,
      volume_path: path,
      volume_size: size,
      aggr_name,
    });
  },
  deleteVolumes(volume) {
    return apiClient.delete(`/storage/volumes/${volume}`);
  },
  resizeVolume(volume_name, volume_size, unit) {
    return apiClient.put(`/storage/volumes/${volume_name}/resize`, {
      volume_size,
      size_unit: unit,
    });
  },
  createProject(project_name) {
    return apiClient.post(`/storage/volumes/projects`, { project_name });
  },
  resizeProject(project_name, volume_size, size_unit) {
    return apiClient.put(`/storage/volumes/projects/${project_name}/resize`, {
      volume_size,
      size_unit,
    });
  },
};
